import { Flex, Stack } from '@mantine/core';
import { Text } from '@repo/foundations';
import { AiQualityBadgeController } from '../../../features/AiQualityBadge/AiQualityBadgeController';
import { PopoverPreview } from '../components/PopoverPreview';
import {
	COMPLEXITY_DESCRIPTIONS,
	getRatingDescription,
} from './popoverConstants';

interface ComplexityPopoverProps {
	complexity: string;
}

export function ComplexityPopover({ complexity }: ComplexityPopoverProps) {
	const { title, description } =
		COMPLEXITY_DESCRIPTIONS[complexity.toLowerCase()];

	if (!description) {
		return (
			<Text
				align="start"
				size="sm"
				color="text/primary/default"
				tt="capitalize"
			>
				{complexity}
			</Text>
		);
	}

	const previewContent = (
		<Text align="start" size="sm" color="text/primary/default" tt="capitalize">
			{complexity}
		</Text>
	);

	const dropdownContent = (
		<Stack spacing="sm">
			<Text size="xs" color="text/primary/default" weight="semibold">
				{title}
			</Text>
			<Text size="sm" color="text/secondary/default">
				{description}
			</Text>
		</Stack>
	);

	return <PopoverPreview preview={previewContent} dropdown={dropdownContent} />;
}

interface RatingPopoverProps {
	score: number;
}

export function RatingPopover({ score }: RatingPopoverProps) {
	const { title, description } = getRatingDescription(score);

	const previewContent = (
		<Flex justify="start">
			<AiQualityBadgeController score={score} />
		</Flex>
	);

	const dropdownContent = (
		<Stack spacing="sm">
			<Text size="xs" color="text/primary/default" weight="semibold">
				{title}
			</Text>
			<Text size="sm" color="text/secondary/default">
				{description}
			</Text>
		</Stack>
	);

	return <PopoverPreview preview={previewContent} dropdown={dropdownContent} />;
}
